import { atom } from 'jotai';

import type { ClickAndCollectStore } from '@getjust/gateway';

// Stores the click-and-collect store the user (or `useAutoSelectClickAndCollectStore`)
// last applied, keyed by `shipping_method.id`. Mirrors the `last-pickup-point`
// pattern but keyed per-method because different click-and-collect methods can
// expose entirely different store lists (carried on `method.justClickAndCollectStores`).
//
// Read in `MobileCategoryDetail` to provide an optimistic display value
// during the brief window between segment switch (or method swap) and the
// cart's `selected[0].selectedJustClickAndCollectStore` being repopulated.
// Eliminates the "Chargement..." flash on every re-entry of the Boutique
// segment.
//
// Session-scoped (no persistence across reloads — store handles/distances are
// not durable across cart sessions; address changes will refresh both the
// list and the autoselect target).
export const lastUserClickAndCollectStoreAtom = atom<Record<string, ClickAndCollectStore>>({});
